<template>
	<section class="QucikIconButton-container">
		<el-tooltip :content="tooltip" placement="bottom" effect="light">
			<i class="icon" :class="clazz" @click="click" />
		</el-tooltip>
	</section>
</template>

<script>
	export default {
		props: ["icon", "tooltip"],
	
		computed: {
			clazz() {
				return ` ${this.icon}`;
			},
		},
	
		methods: {
			click() {
				this.$emit("click");
			},
		},
	};
</script>

<style lang="scss" scoped>
	.QucikIconButton-container {
		border-radius: 50%;
		height: 30px;
		width: 30px;
		line-height: 30px;
		text-align: center;
		cursor: pointer;
		transition: 0.5s;
		margin: 0 5px;

		.icon {
			font-size: 1.0rem;
			color: #fff;
		}

		:hover {
			color: #fff;
			font-size: 1.5rem;
		}
	}
</style>